<button
	type="button"
	mat-icon-button
	[disabled]="for?.disabled"
	(click)="openPicker()"
	aria-label="Open calendar"
>
	<mat-icon [ngClass]="{ 'yellow-icon': for?.opened, 'grey-icon': !for?.opened }">date_range</mat-icon>
</button>
